module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builder__color-option"
  }, [_c('div', {
    staticClass: "builder__color-option-name-and-current-choice"
  }, [_c('div', {
    staticClass: "builder__color-option-name"
  }, [_vm._v("\n      " + _vm._s(_vm.option.is_embroidery_grouped ? (_vm.option.display_title ? _vm.option.display_title : _vm.option.title) : 'Color') + ":\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "builder__color-option-current-choice"
  }, [_vm._v("\n      " + _vm._s(_vm.chosenLabel) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "builder__color-option-choices"
  }, [_vm._l((_vm.option.choices), function(choice) {
    return _c('div', {
      staticClass: "builder__color-option-choice",
      class: {
        'builder__color-option-choice--disabled': choice.is_disabled == 1
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selection),
        expression: "selection"
      }],
      staticClass: "builder__color-option-choice-input",
      attrs: {
        "type": "radio",
        "id": _vm.domId(choice.id),
        "disabled": choice.is_disabled == 1
      },
      domProps: {
        "value": choice.id,
        "checked": _vm._q(_vm.selection, choice.id)
      },
      on: {
        "change": function($event) {
          _vm.selection = choice.id
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "builder__color-option-choice-label",
      class: {
        'builder__color-option-choice-label--disabled': choice.is_disabled == 1
      },
      attrs: {
        "for": _vm.domId(choice.id)
      }
    }, [_c('span', {
      staticClass: "builder__color-option-choice-label-fake-input",
      style: ({
        backgroundColor: '#' + (choice.color_hex ? choice.color_hex : '000')
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "builder__color-option-choice-label-text builder__color-option-choice-label-text--hidden"
    }, [_vm._v(_vm._s(choice.title))])])])
  }), _vm._v(" "), (!_vm.option.is_required) ? _c('div', {
    staticClass: "builder__color-option-choice builder__color-option-choice--none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection),
      expression: "selection"
    }],
    staticClass: "builder__color-option-choice-input",
    attrs: {
      "type": "radio",
      "id": _vm.domId('none')
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.selection, null)
    },
    on: {
      "change": function($event) {
        _vm.selection = null
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "builder__color-option-choice-label",
    attrs: {
      "for": _vm.domId('none')
    }
  }, [_c('span', {
    staticClass: "builder__color-option-choice-label-fake-input"
  }), _vm._v(" "), _c('span', {
    staticClass: "builder__color-option-choice-label-text"
  }, [_vm._v(_vm._s(_vm.noneLabel))])])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37425a7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/option-types/Color.vue
// module id = 369
// module chunks = 0